import React, { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { useHistory } from 'react-router-dom';

const ITEM_HEIGHT = 48;

const TableContextMenuComponent = ({ row, menuOptions, isInvoice = false }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const history = useHistory()
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const HandleOptionClick = (row, option) => {
    switch (option) {
        case 'Detalle':
            if (isInvoice) {
                history.push(`/purchase/orderDetail/${row.folioOrder}?isInvoice=1`)
            }
            else {
                history.push(`/purchase/orderDetail/${row.folioOrder}`)
            }
        break
      default:
        break
    }
  }

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: '20ch'
          }
        }}
      >
        {
          menuOptions.map((option) => (
            <MenuItem key={option} onClick={() => HandleOptionClick(row, option)}>
              {option}
            </MenuItem>
          ))
        }
      </Menu>
    </div>
  )
}

export default TableContextMenuComponent